import ApiResponse from "../ApiResponse";
import {ApiAuthRequestInterface, BuildAuthRequestFromAppState} from "../../authentication/BuildAuthRequestInterface";
import {ApiErrorReturn} from "../ApiError";
import ApiUrl, {PortalSource} from "../ApiUrl";

type ChangeUserPasswordResponse = ApiResponse<string>;

const buildFetchRequest = (body: string, apiAuth: ApiAuthRequestInterface): RequestInit => {
    return {
        method: 'post',
        headers: new Headers({
            'auth_token': apiAuth?.auth_token,
            'IsMarketPlace': apiAuth.IsMarketPlace,
            'Agent': apiAuth.Agent,
            'api_version' :apiAuth.api_version,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }),
        body,
    }}
// public string Source { get; set; }
// public string UserName { get; set; }

// public string Phone { get; set; }

type TokenToRefresh = 'RequestEmail' | 'RequestEmailForgotPassword' | 'RequestVoicePin' | 'RequestTextPin';
type BooleanResponse = 'True' | 'False';
interface TokenForRefreshType {
    RequestEmail: BooleanResponse
    Forgot: BooleanResponse
    RequestVoice: BooleanResponse
    RequestText: BooleanResponse
}
const defaultTokens: TokenForRefreshType = {
    RequestEmail: 'False',
    Forgot: 'False',
    RequestVoice: 'False',
    RequestText: 'False',
}
function GetRefreshTypeForApi(RefreshType: TokenToRefresh){
    switch(RefreshType){
        case "RequestEmail":{
            return {...defaultTokens, RequestEmail: 'True'};
        }
        case "RequestVoicePin":{
            return {...defaultTokens, RequestVoice: 'True'};
        }
        case "RequestTextPin":{
            return {...defaultTokens, RequestText: 'True'};
        }
        default:{
            return {...defaultTokens, RequestEmail: 'True'};
        }
    }
}


export async function UpdateUserPasswordToken(RefreshType: TokenToRefresh, UserName: string, Phone: string, errorHandling: ApiErrorReturn): Promise<ChangeUserPasswordResponse | null>{
    const apiAuth = BuildAuthRequestFromAppState(undefined);
    const Source = PortalSource();
    const body = JSON.stringify({
        ...GetRefreshTypeForApi(RefreshType),
        Source,
        Phone,
        UserName
    });
    try {
        const response = await fetch(ApiUrl() + "FFOrderAccount/UpdateUserPasswordToken", buildFetchRequest(body, apiAuth));
        return await response.json() as ChangeUserPasswordResponse;
    }catch(error: unknown){
        errorHandling(error);
        return null;
    }
}
